import styled from 'styled-components';

export const TlWrap = styled.div`
  position: relative;
  margin: 16px 0 auto;
`;

export const TimelineTrack = styled.div`
  display: flex;
  align-items: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 0 18px;
  position: relative;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='190' height='48'%3E%3Cdefs%3E%3Cfilter id='r'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.013 0.06' numOctaves='2' seed='5' result='n'/%3E%3CfeDisplacementMap in='SourceGraphic' in2='n' scale='4.5'/%3E%3C/filter%3E%3C/defs%3E%3Cpath d='M0,23 Q47,19 95,23 T190,23' fill='none' stroke='%23b4bcc2' stroke-width='3.2' stroke-linecap='round' filter='url(%23r)'/%3E%3C/svg%3E");
  background-repeat: repeat-x;
  background-position: 0 1px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TlArrow = styled.button<{
  $side: 'left' | 'right';
  $avail: boolean;
}>`
  position: absolute;
  top: 23px;
  transform: translateY(-50%);
  ${({ $side }) => ($side === 'left' ? 'left: 0;' : 'right: 0;')}
  z-index: 500;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(30, 50, 55, 0.08);
  border: 1px solid rgba(30, 50, 55, 0.14);
  color: rgba(40, 55, 60, 0.55);
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  opacity: ${({ $avail }) => ($avail ? 1 : 0)};
  pointer-events: ${({ $avail }) => ($avail ? 'auto' : 'none')};
  transition:
    opacity 0.25s ease,
    background 0.15s,
    color 0.15s,
    transform 0.15s;

  &:hover {
    ${({ $avail }) =>
      $avail &&
      `
        background: rgba(30,50,55,.18);
        color: rgba(25,35,40,.9);
        transform: translateY(-50%) scale(1.07);
      `}
  }
`;

export const WeekCol = styled.div`
  position: relative;
  flex: 0 0 auto;
  min-width: 210px;
  padding: 32px 14px 0;
`;

export const WeekNode = styled.div<{ $hidden?: boolean }>`
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%) rotate(-6deg);
  width: 17px;
  height: 17px;
  border-radius: 49% 51% 52% 48%;
  z-index: 2;
  background: #b4bcc2;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    inset 0 1px 2px rgba(255, 255, 255, 0.4);
  ${({ $hidden }) => $hidden && 'opacity: 0;'}
`;

export const WeekChip = styled.div<{ $hidden?: boolean }>`
  text-align: center;
  margin-bottom: 12px;
  ${({ $hidden }) => $hidden && 'opacity: 0;'}
`;

export const WeekKw = styled.span`
  font-family: var(--hand);
  font-size: 18px;
  font-weight: 700;
  color: #9aa3aa;
  letter-spacing: 0.5px;
  line-height: 1;
  display: block;
`;

export const WeekRange = styled.div`
  font-family: var(--hand);
  font-size: 13px;
  font-weight: 500;
  color: #aab2b8;
  margin-top: 1px;
  letter-spacing: 0.3px;
`;

export const CardStack = styled.div<{ $width: number; $height: number }>`
  position: relative;
  margin: 0 auto;
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
`;

export const StackBadge = styled.div`
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(calc(-50% + 86px));
  background: #2e333a;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  font-family: var(--body);
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
`;

export const SampleNote = styled.div`
  position: relative;
  width: 170px;
  border-radius: 3px;
  padding: 18px 13px 13px;
  background: repeating-linear-gradient(
    135deg,
    #eef2f4,
    #eef2f4 9px,
    #e6ebee 9px,
    #e6ebee 18px
  );
  border: 1.5px dashed #b4bcc2;
  color: #5a6066;
`;

export const SampleMagnet = styled.div`
  position: absolute;
  top: -9px;
  left: 50%;
  transform: translateX(-50%);
  width: 19px;
  height: 19px;
  border-radius: 50%;
  z-index: 4;
  background: radial-gradient(
    circle at 35% 30%,
    #fff,
    #d4dade 45%,
    #9aa3aa 100%
  );
  box-shadow:
    0 3px 7px rgba(0, 0, 0, 0.45),
    inset 0 1px 2px rgba(255, 255, 255, 0.85),
    inset 0 -2px 4px rgba(0, 0, 0, 0.4);
`;

export const SnTag = styled.div`
  display: inline-block;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: #8a949b;
  margin-bottom: 5px;
`;

export const SnQ = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #5a6066;
  line-height: 1.4;
  margin-bottom: 8px;
`;

export const SnHint = styled.div`
  font-size: 10px;
  font-style: italic;
  color: #8a949b;
  line-height: 1.4;
`;

export const PlaceholderSlot = styled.div`
  width: 170px;
  min-height: 176px;
  margin: 0 auto;
`;
